import { render, staticRenderFns } from "./specific-nuorder.vue?vue&type=template&id=0af5940a&"
import script from "./specific-nuorder.vue?vue&type=script&lang=js&"
export * from "./specific-nuorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports